import React from 'react';
import PropTypes from 'prop-types';
import Overflow from './ui/Overflow';

class Bookings extends React.Component {

    render() {
        return (
            <div>
                <h4>Manage bookings</h4>
                <div className="flex-between">
                    <div></div>
                    <a className="btn btn-primary btn-with-icon" onClick={this.props.addBooking}><i className="material-icons">add_circle_outline</i>Add booking</a>
                </div>
                <table className="table productTable bookingsTable">
                    <thead>
                        <tr>
                            <th className="iconCell"></th>
                            <th className="titleCell">Title</th>
                            <th>Max attendees</th>
                            <th>Cost</th>
                            <th>Duration</th>
                            <th>Host</th>
                            <th className="iconCell"></th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            Object.keys(this.props.bookings).map(key => {
                                const booking = this.props.bookings[key];
                                if(booking) {
                                    return (
                                        <tr key={key}>
                                            <td className="iconCell"><i className="material-icons">today</i></td>
                                            <td className="titleCell productTitle" onClick={() => this.props.showBookingsModal(key) }>{booking.name}</td>
                                            <td >{booking.maxAttendees}</td>
                                            <td >{booking.cost}</td>
                                            <td >{booking.duration}</td>
                                            <td >{booking.host}</td>
                                            <td className="iconCell">
                                                <Overflow
                                                    options={[  {label: "Edit", icon: "border_color", action: this.props.showBookingsModal}
                                                            ]}
                                                    argument={key}
                                                />
                                            </td>
                                        </tr>
                                    );
                                }
                                else {
                                    return null;
                                }
                            })
                        }
                    </tbody>
                </table>
            </div>
        );
    }
}

Bookings.propTypes ={
    bookings: PropTypes.object.isRequired,
    showBookingsModal: PropTypes.func.isRequired
}

export default Bookings;


/** WEBPACK FOOTER **
 ** ./src/components/Bookings.js
 **/